const HiltonDiamond = props => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_301_96)">
      <g>
        <path
          d="M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z"
          fill="#562051"
        />
        <path
          d="M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z"
          fill="white"
          fillOpacity={0.08}
        />
        <path
          d="M14 2.3422C15.2376 1.62767 16.7624 1.62767 18 2.3422L26.6656 7.3453C27.9032 8.05983 28.6656 9.38034 28.6656 10.8094V20.8156C28.6656 22.2447 27.9032 23.5652 26.6656 24.2797L18 29.2828C16.7624 29.9973 15.2376 29.9973 14 29.2828L5.33438 24.2797C4.09677 23.5652 3.33438 22.2447 3.33438 20.8156V10.8094C3.33438 9.38034 4.09677 8.05983 5.33438 7.3453L14 2.3422Z"
          fill="url(#paint0_linear_301_96)"
          fillOpacity={0.2}
        />
      </g>
      <g filter="url(#filter0_d_301_96)">
        <path
          d="M10.5313 9.7H15.4903C19.4898 9.7 22.1593 12.341 22.1593 16.35C22.1593 20.359 19.4898 23 15.4903 23H10.5313V9.7ZM13.6853 20.264H15.3003C17.5043 20.264 18.9863 18.934 18.9863 16.35C18.9863 13.766 17.5043 12.436 15.3003 12.436H13.6853V20.264Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        x={8.53125}
        y={9.7}
        width={15.6279}
        height={17.3}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_301_96"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_301_96"
          result="shape"
        />
      </filter>
      <linearGradient
        x1={16}
        y1={1.1875}
        x2={16}
        y2={30.4375}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <clipPath>
        <rect width={32} height={32} fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default HiltonDiamond
